export default "__VITE_ASSET__DzJa3vFv__"